import { getParentIframe } from "./getParentIframe";
import { getQueryParameter } from "./getQueryParameter";
import { isLoadedInIframe } from "./isLoadedInIframe";

export function getQueryStringVariable(variable) {
	var value = getQueryParameter(window.location.href,variable);
	
	if(!value && isLoadedInIframe()) {
			try {
				value = getQueryParameter(getParentIframe()?.location?.href,variable);
			}catch(err) {
				console.error(err);
			}
			
	}
		
	return value;
}
